module.exports = __webpack_public_path__ + "static/media/verdeSweetheart.47f73dfc.jpg";